// extracted by mini-css-extract-plugin
export default {"container":"Info_container__1+qUD","info":"Info_info__+d1Y4","title":"Info_title__GyATx","description":"Info_description__GBxuk"};